import { z } from 'zod'
import i18n from '@/lib/i18n'

export const vereAgirSchema = z.object({
	date: z.string().refine((val) => !Number.isNaN(Date.parse(val)), {
		message: i18n.t('form.seeAndAct.dateError'),
	}),
	customerClassificationId: z.string().optional(),
	kindId: z.uuid(i18n.t('form.seeAndAct.typologyError')),
	riskId: z.uuid(i18n.t('form.seeAndAct.riskError')),
	potential: z.string().optional(),
	description: z.string().min(10, i18n.t('form.seeAndAct.descriptionError')),
	immediateAction: z
		.string()
		.min(10, i18n.t('form.seeAndAct.immediateActionError')),
	responsibleId: z.uuid(i18n.t('form.seeAndAct.responsibleError')),
	dueDate: z.string().refine((val) => !Number.isNaN(Date.parse(val)), {
		message: i18n.t('form.seeAndAct.dueDateError'),
	}),
	status: z.string().min(1, i18n.t('form.seeAndAct.statusError')),
	situation: z.string().min(1, i18n.t('form.seeAndAct.situationError')),
	image: z.any().optional(),
})

// input (o que o form manda para o resolver)
export type VereAgirInput = z.input<typeof vereAgirSchema>

// output (já coercido/validado; com Date)
export type VereAgirFormData = z.output<typeof vereAgirSchema>
